import React, {useRef, useState} from "react";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {useHistory} from "react-router-dom";
import {
    ACTION_TEXT,
    ACTIVITY_TITLE_TEXT,
    CODE_TEXT,
    ACTIVITY_LINK_TEXT,
    LIVE_ACTIVITIES_DESCRIPTION,
    LIVE_ACTIVITIES_TEXT,
    POLL_STATUS_HEADER,
    SHARED_ENTIRELY,
    TEXTBOX,
    VIEW_ACTIVITIES_TEXT,
    COPY_LINK_TEXT,
    COPIED_TEXT,
} from "../../utils/constants";
import {getPollStatus, getShortName, removePrefixNew} from "../../utils/helpers";
import styles from "./DashboardPage.module.css";
import {ReactComponent as ActivePollIcon} from "./images/gradient_radar_icon.svg";
import {ReactComponent as COPY_ICON} from "../../images/copy_gray.svg";

import {Table} from "react-bootstrap";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {useConfig} from "../../hooks/useConfig";
import {Button} from "@base-ui/react/button";

export default function DashboardCardLiveActivities({data = [], loading = true}) {
    const history = useHistory();
    const config = useConfig();
    const panelBodyRef = useRef();
    const [copied, setCopied] = useState("");
    const clipBoardRef1 = useRef();
    const clipBoardRef2 = useRef();
    const clipBoardRef3 = useRef();

    const refArr = [clipBoardRef1, clipBoardRef2, clipBoardRef3];

    let shortName = getShortName();


    const viewResult = (poll) => {
        const {pk, index3Pk} = poll;
        history.push({
            pathname: `/poll/share/${removePrefixNew(pk)}/${removePrefixNew(index3Pk)}`,
            // state: { expandedAnalytics: true }
        });
    }

    // useEffect(() => {
    //
    //     let timeOutId = setTimeout(() => {
    //         setCopied("");
    //     }, 3000);
    //
    //
    //     return () => {
    //         if (timeOutId) {
    //             clearTimeout(timeOutId);
    //         }
    //     }
    //
    // }, [copied]);

    if (loading) {
        return (
            <div style={{height: 250, width: "100%"}}>
                <Skeleton borderRadius={10} height={"100%"} width={"100%"}/>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return <></>;
    }

    return (
        <div className={`${styles.panelContainer} ${styles.topCard}`} style={{display: "flex", flexDirection: "column"}}>
            <div className={styles.panelTitle}>
                <ActivePollIcon style={{marginRight: "15px", flexShrink: 0, width: 18, height: 18}}/>
                <div role={TEXTBOX} >{LIVE_ACTIVITIES_TEXT}</div>
            </div>
            <div className={styles.panelBody} ref={panelBodyRef}>
                {/* <Spin size="large" wrapperClassName="panelSpin" spinning={loading} tip="Loading..." style={{height: "100%"}}> */}
                <div role={TEXTBOX} className={styles.panelDescription} style={{alignSelf: "start"}}>
                    {LIVE_ACTIVITIES_DESCRIPTION}
                </div>

                <div className={styles.tableWrapper}>
                    <Table className={styles.recentResultTable} hover>
                        <thead>
                        <tr>
                            <th style={{width: 200, minWidth: 0, textAlign: "left"}}>{ACTIVITY_TITLE_TEXT}</th>
                            <th style={{width: 120, minWidth: 0}}>{CODE_TEXT}</th>
                            <th style={{width: 180, minWidth: 0}}>{POLL_STATUS_HEADER}</th>
                            <th style={{width: 120, minWidth: 0,}}>{ACTIVITY_LINK_TEXT}</th>
                            <th style={{width: 120, minWidth: 0,}}>{ACTION_TEXT}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {JSON.parse(JSON.stringify(data)).splice(0, 3).map((poll, index) => {
                            let pollStatus = getPollStatus(poll);
                            let badgeClass = pollStatus === SHARED_ENTIRELY ? styles.releaseEntirely : styles.releaseSingle;
                            let pollCode = removePrefixNew(poll.sk);

                            return (
                                <tr key={index} style={{cursor: "pointer"}}
                                    onClick={() => viewResult(poll)}>
                                    <td className={styles.omitableText}
                                        style={{textAlign: "left"}}>{poll.pollTitle}</td>
                                    <td >{pollCode}</td>
                                    <td >
                                        <div style={{display: "flex"}}>
                                            <span className={`${styles.badge} ${badgeClass}`} style={{width: 180}}>
                                               {pollStatus}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <YuJaTooltip
                                            disableHoverablePopup={true}
                                            text={copied !== pollCode
                                                ? "Copy activity link to share with participants"
                                                : COPIED_TEXT
                                            }
                                            placement={"bottom"}
                                            onOpenChangeCb={(isOpen) => {
                                                if (!isOpen) {
                                                    setCopied("");
                                                }
                                            }}
                                        >
                                            <Button
                                                style={{display: "inline-block"}}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    refArr[index].current.onClick();
                                                }}
                                            >
                                                <CopyToClipboard
                                                    ref={refArr[index]}
                                                    text={`${shortName}.${config.host_url}/qr/${pollCode}`}
                                                    onCopy={() => {
                                                        setCopied(pollCode);
                                                    }}
                                                >
                                                    <div className={`${styles.copyLinkBtn} ${styles.row} ${copied === pollCode ? styles.copied : ""}`}>
                                                        <div >{COPY_LINK_TEXT}</div>
                                                        <COPY_ICON aria-hidden={true} style={{width: 24, height: 24, marginLeft: 5, flexShrink: 0}}/>
                                                    </div>
                                                </CopyToClipboard>
                                            </Button>
                                        </YuJaTooltip>

                                    </td>
                                    <td>
                                        <Button
                                            className={styles.gradientButton}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                viewResult(poll);
                                            }}
                                        >
                                            {VIEW_ACTIVITIES_TEXT}
                                        </Button>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>


                {/*<div className={styles.modifiedPollContainer}>*/}
                {/*    {JSON.parse(JSON.stringify(data)).splice(0, 3).map((poll, index) => (*/}
                {/*        <div key={index}*/}
                {/*             className={styles.modifiedPollUnit}*/}
                {/*             style={{*/}
                {/*                 display: "flex",*/}
                {/*                 alignItems: "center",*/}
                {/*                 justifyContent: "space-between"*/}
                {/*             }}*/}
                {/*        >*/}
                {/*            <span style={{display: "flex", width: "55%"}}>*/}
                {/*                <span role={TEXTBOX} tabIndex={0}*/}
                {/*                      className={styles.omitableText}>{poll.pollTitle}</span>*/}
                {/*                <CopyToClipboard*/}
                {/*                    text={`${shortName}.${config.host_url}/qr/${removePrefixNew(poll.index5Sk)}`}>*/}
                {/*                    <div onClick={() => notifySuccess(COPY_URL_SUCCESS)} role={TEXTBOX}*/}
                {/*                         aria-label={"Copy Join Poll Link"} tabIndex={0}>*/}
                {/*                        <Copy*/}
                {/*                            title={"copy join poll link"}*/}
                {/*                            style={{*/}
                {/*                                marginLeft: "5px",*/}
                {/*                                maxWidth: "20px",*/}
                {/*                                maxHeight: "20px",*/}
                {/*                                cursor: "pointer"*/}
                {/*                            }}*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*            </CopyToClipboard>*/}
                {/*            </span>*/}
                {/*            /!* <span*/}
                {/*                tabIndex={0}*/}
                {/*                aria-label={"View results summary for poll " + poll.pollTitle}*/}
                {/*                role={BUTTON}*/}
                {/*                title={"go to poll page"}*/}
                {/*                style={{width: "45%", marginLeft: "10px", textAlign: "end", cursor: "pointer"}}*/}
                {/*                className={`${styles.gradientText} ${styles.linkText}`}*/}
                {/*                onClick={() => viewResult(poll)}*/}
                {/*            >*/}
                {/*                View Result Summary*/}
                {/*            </span> *!/*/}
                {/*            <GradientButton*/}
                {/*                role={TEXTBOX}*/}
                {/*                label={VIEW_RESULTS + poll.pollTitle}*/}
                {/*                style={{marginLeft: "15px"}}*/}
                {/*                onClick={() => viewResult(poll)}*/}
                {/*            >*/}
                {/*                {VIEW_RESULTS_TEXT}*/}
                {/*            </GradientButton>*/}
                {/*        </div>*/}
                {/*    ))}*/}
                {/*</div>*/}

                {/* </Spin> */}
            </div>

        </div>
    );
}